import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model'
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {Api} from '@shared/constants/common-field.constants';
import {take} from 'rxjs/operators';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ExpertServiceFirm, ExpertServiceTemplate} from '@features/expert-services/models/expert-services.model';

@Component({
    standalone: false,
    selector: 'app-copy-to-workspace-dialog',
  templateUrl: './copy-to-workspace-dialog.component.html',
  styleUrls: ['./copy-to-workspace-dialog.component.scss']
})
export class CopyToWorkspaceDialogComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  expertServiceWorkspaces: any[];
  expertServices: any[];

  selectorForm: FormGroup;

  constructor(private platformQueryService: PlatformQueryService,
              private formBuilder: FormBuilder,
              @Inject(MAT_DIALOG_DATA) public dialogInfo: DialogModel) {
  }

  ngOnInit(): void {
    this.data.isDisabledOkButton = true;
    this.selectorForm = this.formBuilder.group({
      message: [''],
      expertServiceWorkspace: ['', [Validators.required]],
      selectedService: ['', [Validators.required]],
    });
    this.getExpertServiceWorkspaces();
    this.selectorForm.valueChanges.subscribe(() => {
      this.data.isDisabledOkButton = this.selectorForm.invalid;
    });
    this.selectorForm.get('expertServiceWorkspace').valueChanges.subscribe(res => {
      this.mapWithSelectedData(res.id);
    });
  }

  onOkClicked(): boolean {
    if (this.selectorForm.valid) {
      this.data.input.message = this.selectorForm.get('message').value;
      this.data.input.selectedService = this.selectorForm.get('selectedService').value;
      return true;
    }
    return false;
  }

  private getExpertServiceWorkspaces() {
    const query = new PlatformQuery();
    query.name = 'ExpertServiceWorkspaceQuery';
    query.api = Api.MarketPlace;
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues) {
        this.expertServiceWorkspaces = response.fieldValues['ExpertServiceWorkspace'];
      }
    });
  }

  private mapWithSelectedData(expertServiceWorkspaceId: string) {
    const query = new PlatformQuery();
    query.name = 'ExpertServiceModelsByWorkspaceIdQuery';
    query.api = Api.MarketPlace;
    query.setValue('ExpertServiceWorkspaceId', expertServiceWorkspaceId);
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues) {
        this.expertServices = response.fieldValues['ExpertServiceModels'];
        this.selectorForm.get('selectedService').patchValue('', {onlySelf: true, emitEvent: false});
        this.dialogInfo.isDisabledOkButton = true;
      }
    });
  }

  onCancelClicked(): any {
  }

  ngOnDestroy(): void {
  }
}
